import { z } from 'zod'
import { trainerChannelMessageSchema, TRAINER_CHANNEL_READ_CONTRACT_VERSION } from './trainer-channel-read'
import { trainerErrorEnvelopeSchema } from './trainer-event-read'

const trainerChannelMessageWriteSideEffectsSchema = z.object({
  db1Written: z.boolean(),
  auditWritten: z.boolean(),
  billingTouched: z.literal(false),
  eventEmitted: z.literal(false),
  uploadTouched: z.literal(false),
  r2Touched: z.literal(false),
  llmTouched: z.literal(false),
  queuePublished: z.boolean(),
  db2Touched: z.literal(false),
}).passthrough()

export const trainerChannelMessageCreateResponseSchema = z.object({
  contract_version: z.literal(TRAINER_CHANNEL_READ_CONTRACT_VERSION),
  message: trainerChannelMessageSchema,
  idempotentReplay: z.boolean(),
  sideEffects: trainerChannelMessageWriteSideEffectsSchema,
}).passthrough()

export const trainerChannelClientMessageResponseSchema = trainerErrorEnvelopeSchema

export type TrainerChannelMessageCreateResponse = z.infer<typeof trainerChannelMessageCreateResponseSchema>
export type TrainerChannelClientMessageResponse = z.infer<typeof trainerChannelClientMessageResponseSchema>
